var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ spinner: true, active: _vm.state }},[_c('div',{staticClass:"spinner-glyph"})])}
var staticRenderFns = []

export { render, staticRenderFns }